module.exports = __webpack_public_path__ + "img/smp-map-v2-1024x493.c97db6df.jpg";